<button type="button"
  id="zoomOut"
  class="toolbarButton zoomOut"
  title="Zoom Out"
  data-l10n-id="zoom_out">
  <span data-l10n-id="zoom_out_label">Zoom Out</span>
</button>
